/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum ProductEnum {
  KONAN = "konan",
  SYNAPSE_ID = "synapse_id",
}
